import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LayoutModule } from "../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../freightconfirmation/app.sharemodule";
import { TranslateModule } from "@ngx-translate/core";
import { MapComponent } from "./map.component";

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        FormsModule,
        SharedModule,
        TranslateModule.forChild(),
    ],
    exports: [MapComponent],
    declarations: [MapComponent]
})
export class MapSharedModule { }
